import React, {useRef, useState} from "react";
import {ReactComponent as CalenderCheckIcon} from "../../../assets/icons/CalendarCheck.svg";
import dayjs from "dayjs";
import {ReactComponent as ClockIcon} from "../../../assets/icons/Clock.svg";
import {ReactComponent as ClockClockwiseIcon} from "../../../assets/icons/ClockClockwise.svg";
import {ReactComponent as SeperatorIcon} from "../../../assets/icons/Seperator.svg";
import {ReactComponent as ShareIcon} from "../../../assets/icons/Share.svg";
import TotalAttendees from "../Attendees/TotalAttendees/TotalAttendees";
import "./meetingHeader.scss";
import PropTypes from "prop-types";
import AttendeeChip from "../Attendees/AttendeeChip/AttendeeChip";
import {Button, Tooltip} from "@mui/material";
import {useSearchParams} from "react-router-dom";
import {ACCESS_TOKEN_QUERY_PARAM_NAME, SHOW_SHARE_BUTTON} from "../constants";

const MeetingHeader = ({createLinkToMeetingDetails,
                           showAttendeeNames,
                           title,
                           dateTime,
                           duration,
                           prospectCompany,
                           callStage,
                           conversationId,
                           attendees,
                           displayConfig}) => {

    const [searchParams] = useSearchParams();
    const accessToken = searchParams.get(ACCESS_TOKEN_QUERY_PARAM_NAME);
    const anchorEl = useRef();
    const [showLinkCopied, setShowLinkCopied] = useState(false);

    const copyUrlToClipboard = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setShowLinkCopied(true);
        navigator.clipboard.writeText(`${window.location.origin}/meeting-details/${conversationId}?includeCallScore=true&o=${accessToken}`);
        setTimeout(() => {
            setShowLinkCopied(false);
        },2000);
    }

    return (<>
        <div className={"heading"}>
            <p className={`meeting-title ${createLinkToMeetingDetails ? "" : "margin-top-16"}`}>{title}</p>
            {
                SHOW_SHARE_BUTTON && displayConfig?.showShareButton && <Tooltip open={showLinkCopied} title={"Link Copied!"}
                                                             placement={"right"} classes={{tooltip: "link-copied-tooltip"}} arrow>
                    <Button className={`share-button ${createLinkToMeetingDetails ? "add-min-width" : ""}`} onClick={copyUrlToClipboard} ref={anchorEl}>
                        <ShareIcon />
                    </Button>
                </Tooltip>
            }
        </div>

        <div style={{display: "flex", justifyContent: "space-between"}} className={"meeting-header-container"}>
            <div className={"meeting-details"}>
                {
                    !!dateTime && <>
                        <div className={"header-field"}>
                            <CalenderCheckIcon/>
                            <p className={"date"}>{dayjs(dateTime).format("DD MMM YY")}</p>
                        </div>
                        <div className={"header-field"}>
                            <ClockIcon/>
                            <p className={"time"}>{dayjs(dateTime).format('LT')}</p>
                        </div>
                    </>
                }
                {
                    !!duration && <div className={"header-field"}>
                        <ClockClockwiseIcon/>
                        <p className={"duration"}>{duration}</p>
                    </div>
                }
                {
                    !!prospectCompany && <div className={"header-field"}>
                        <SeperatorIcon/>
                        <p className={"prospect"}>{prospectCompany}</p>
                    </div>
                }
                {
                    !!callStage && <div className={"header-field"}>
                        <SeperatorIcon/>
                        <p className={"call-stage"}>{callStage}</p>
                    </div>
                }
                {
                    attendees?.length > 0 && !showAttendeeNames && <div className={"header-field"}><SeperatorIcon/><TotalAttendees attendees={attendees} /></div>
                }
            </div>
        </div>
        { attendees?.length > 0 && showAttendeeNames && <div className={"attendees-names"}> {attendees.map(({name}, index) => <AttendeeChip key={index} name={name} index={index}/>)}</div>}
    </>)
}

export default MeetingHeader;

MeetingHeader.prototype = {
    title: PropTypes.string,
    dateTime: PropTypes.string,
    duration: PropTypes.string,
    prospectCompany: PropTypes.string,
    callStage: PropTypes.string,
    attendees: PropTypes.array,
    conversationId: PropTypes.string,
    createLinkToMeetingDetails: PropTypes.bool,
    showAttendeeNames: PropTypes.bool,
    displayConfig: PropTypes.objectOf({
        showShareButton: false
    }),
}